<template>
  <Modal v-if="display" @hideModal="toggleModal" :wide="true">
    <h1 class="font-bold text-lg">Enter your address</h1>
    <ClientOnly>
      <AddressInput :redirectPath="redirectPath" @addressLookupComplete="hide" />
    </ClientOnly>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Define props
defineProps<{
  redirectPath: string;
}>();

// Reactive state
const display = ref(false);
const smartyStreetsResults = ref<any>(null);
const addressSearch = ref("");

// Methods
const show = () => {
  display.value = true;
};

const hide = () => {
  display.value = false;
};

const toggleModal = () => {
  display.value = !display.value;
};

defineExpose({show, hide, toggleModal});

</script>
